import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const threadCPUSchema: Schema = {
  title: 'TiKV Thread CPU',
  subTitle: `Refers to <a target="_blank" href="https://docs.pingcap.com/tidb/stable/tune-tikv-thread-performance">DoC: Tune TiKV Thread Pool Performance</a>`,
  level: 1,
  columns: commonColumns
}
